import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CampaignCurrency, VALUE_FIRST_CURRENCIES, brandInitial, detectCampaignCurrency } from '../../../onboarding-value-first/services/value-first-onboarding.types';
import { ValueFirstAgencyService } from '../../services/value-first-agency.service';

@Component({
  selector: 'vfa-found-step',
  templateUrl: './found-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex h-0 min-h-0 flex-1 flex-col' },
})
export class VfaFoundStep {
  readonly onboarding = inject(ValueFirstAgencyService);
  readonly currencies = VALUE_FIRST_CURRENCIES;
  readonly descriptionOpen = signal(false);

  initial(): string {
    return brandInitial(this.onboarding.agencyName());
  }

  descriptionClass(): string {
    return this.descriptionOpen() ? '' : 'line-clamp-3 lg:line-clamp-4';
  }

  showDescriptionToggle(): boolean {
    return (this.onboarding.draft().agency?.description?.length ?? 0) > 180;
  }

  toggleDescription(): void {
    this.descriptionOpen.update((open) => !open);
  }

  chooseCurrency(currency: CampaignCurrency): void {
    this.onboarding.setCurrency(currency);
  }

  currencyDetected(): boolean {
    const agency = this.onboarding.draft().agency;
    if (!agency) {
      return false;
    }
    const detection = detectCampaignCurrency(agency.domain, agency.countryCode);
    return detection.detected && detection.currency === this.onboarding.activeCurrency();
  }

  edit(): void {
    this.onboarding.editAgency();
  }

  reject(): void {
    this.onboarding.rejectAgency();
  }

  continueToBrands(): void {
    this.onboarding.continueToBrands();
  }
}
